module.exports = __webpack_public_path__ + "7e4b29ba/img/pwrd-by-sourcery-black.bba9ba41.svg";